import React from 'react';
import { ReplaceCard } from 'features/card/replace-card';
import { Flex } from 'antd';
import Result from 'shared/ui/Result';
import { useIntl } from 'react-intl';

const Success: React.FC<{ cardNumber: string }> = ({ cardNumber }) => {
  const {formatMessage: t} = useIntl();

  return (
    <Flex align="center" justify="center" style={{ flex: 1, minHeight: '60vh' }} vertical>
      <Result
        type="success"
        title={ t({ id: 'success.title' },{ cardNumber: cardNumber.slice(-4) }) }
      />
      <Flex vertical gap={16} align="center" style={{ marginTop: 32, width: 260 }}>
        <ReplaceCard label={ t({ id: 'success.order' }) } type="primary" block size="large" />
      </Flex>
    </Flex>
  );
};

export default Success;
